import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35eac5d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caron-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sty" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-title" }, "区域碳排放监测", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "单位：ppm", -1))
const _hoisted_5 = { class: "list-content" }
const _hoisted_6 = { class: "no-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
        default: _withCtx(() => [
          _createVNode(_component_Table, {
            columns: _ctx.columns,
            scroll: {
              y: '3.2rem'
            },
            "data-source": _ctx.tableData,
            pagination: false
          }, null, 8, ["columns", "scroll", "data-source"])
        ]),
        _: 1
      }, 8, ["locale"])
    ], 512), [
      [_vShow, !_ctx.isEmpty]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
      [_vShow, _ctx.isEmpty]
    ])
  ]))
}